import React from 'react';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import { Page, Report as PowerBIReport } from 'powerbi-client';
import PDFModel from './model';

// Initialize pdfMake with fonts
// @ts-ignore - Add ts-ignore to bypass TypeScript error for pdfMake fonts initialization
pdfMake.vfs = pdfFonts.pdfMake ? pdfFonts.pdfMake.vfs : pdfFonts;

interface ButtonProps {
  reportRef1: React.MutableRefObject<PowerBIReport | null>;
  reportRef2: React.MutableRefObject<PowerBIReport | null>;
  paintProvided: boolean;
  exportName: string;
}

const PDFExportButton: React.FC<ButtonProps> = ({ reportRef1, reportRef2, paintProvided, exportName }) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const exportPDF = async () => {
    setIsLoading(true);

    if (!reportRef1.current || !reportRef2.current) {
      console.error('Report container not found.');
      setIsLoading(false);
      return;
    }

    const report1 = reportRef1.current;
    const report2 = reportRef2.current;
    if (!report1 || !report2) {
      console.error('Report not found.');
      setIsLoading(false);
      return;
    }

    try {
      let table = new PDFModel();

      let allExportPromises = [] as Promise<any>[];

      let pages1: Page[] = await report1.getPages();
      let pages2: Page[] = await report2.getPages();

      let activePages1 = pages1.filter((page: Page) => page.isActive);
      let activePages2 = pages2.filter((page: Page) => page.isActive);

      for (const page of activePages1) {
        const visuals = await page.getVisuals();

        for (const visual of visuals) {
          if (
            visual.type === 'tableEx' ||
            visual.type === 'card' ||
            visual.type === 'cardVisual' ||
            visual.type === 'slicer'
          ) {
            allExportPromises.push(table.maybeAddTable(visual));
          }
        }
      }

      for (const page of activePages2) {
        const visuals = await page.getVisuals();

        for (const visual of visuals) {
          if (
            visual.type === 'tableEx' ||
            visual.type === 'card' ||
            visual.type === 'cardVisual' ||
            visual.type === 'slicer'
          ) {
            allExportPromises.push(table.maybeAddTable(visual));
          }
        }
      }

      // Wait for all export promises to resolve
      await Promise.all(allExportPromises);

      // Generate PDF with pdfMake
      table.export(
        () => {
          setIsLoading(false);
        },
        paintProvided,
        exportName
      );
    } catch (error) {
      console.error('Error exporting visual data:', error);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <button onClick={exportPDF} style={{ ...styles.button }} disabled={isLoading}>
        {isLoading ? 'Exporting...' : 'Export as PDF'}
      </button>
    </div>
  );
};

const styles = {
  button: {
    height: '5.6vh',
    width: '24vh',
    fontSize: '1.6vh',
    fontWeight: '700',
    color: '#ffffff',
    backgroundColor: 'rgba(0, 171, 155, 1)', // Blue color
    border: 'none',
    borderRadius: '1.6vh',
    cursor: 'pointer',
    transition: 'background-color 0.3s, transform 0.2s',
    outline: 'none',
  },
  buttonHover: {
    backgroundColor: '#c0392b',
    transform: 'translateY(-0.2vh)',
  },
};

export default PDFExportButton;
